<script>
import envelope from '@/assets/envelope.svg';
import github from '@/assets/github.svg';
import linkedIn from '@/assets/linkedin.svg';

export default {
  data() {
    return {
      envelope,
      github,
      linkedIn,
    }
  },
}
</script>

<template>
  <div id="app">
    <h1>
      Lars Myrup
    </h1>
    <h2>
      Full Stack Developer
    </h2>
    <div style="margin-top: 25px">
      Come Say Hi 🥳
    </div>
    <div style="display: flex; justify-content: center; margin-top: 20px">
      <a
          href="https://www.linkedin.com/in/lars-myrup-376514121/"
          target="_blank"
      >
        <img
            alt="LinkedIn icon"
            class="home__icon"
            :src="linkedIn"
        />
      </a>
      <a
          href="https://github.com/Larsmyrup"
          target="_blank"
      >
        <img
            alt="Github icon"
            class="home__icon"
            :src="github"
        />
      </a>
      <a
          href="mailto:hej@larsmyrup.dk"
      >
        <img
            alt="Email icon"
            class="home__icon"
            :src="envelope"
        />
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$text-color: #2c3e50;
.home {
  &__icon {
    width: 24px;
    height: auto;
    margin: 10px;
    color: $text-color;
    transition: all, 300ms ease-in-out;

    &:hover {
      filter: brightness(200%);
    }

  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  margin-top: 80px;
}
</style>
